// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserTotals
 */
export interface UserTotals {
  /**
   *
   */
  users: number;
}

/**
 * Check if a given object implements the UserTotals interface.
 */
export function instanceOfUserTotals(value: object): value is UserTotals {
  if (!("users" in value) || value["users"] === undefined) return false;
  return true;
}

export function UserTotalsFromJSON(json: any): UserTotals {
  return UserTotalsFromJSONTyped(json, false);
}

export function UserTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTotals {
  if (json == null) {
    return json;
  }
  return {
    users: json["users"],
  };
}

export function UserTotalsToJSON(json: any): UserTotals {
  return UserTotalsToJSONTyped(json, false);
}

export function UserTotalsToJSONTyped(
  value?: UserTotals | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    users: value["users"],
  };
}
